const DieselTracksStyles = `
  :root {
    --diesel-tracks-font-primary: franklin-gothic-condensed, sans-serif;
    --diesel-tracks-accent-color: #E2002B;
    --diesel-tracks-map-inactive-color: #E83355;
    --diesel-tracks-map-hover-color: #F399AA;
  }

  .diesel-tracks-font-primary {
    font-family: var(--diesel-tracks-font-primary);
    font-weight: 400;
    font-style: normal;
  }

  .diesel-tracks-heading {
    font-weight: 600;
    text-transform: uppercase;
  }

  .diesel-tracks {
    background-color: var(--diesel-tracks-accent-color);
    color: var(--nts-white);
    overflow: hidden;
  }

  .diesel-tracks__section:first-child {
    margin-top: 37px;
  }

  .diesel-tracks__hero {
    position: relative;
  }

  .diesel-tracks__hero-diesel-logo {
    display: none;
    left: 0;
    position: absolute;
    top: 0;
    width: 10%;
    z-index: 1;
  }

  .diesel-tracks__bg-image {
    width: 100%;
  }

  .diesel-tracks__bg-image--large {
    display: none;
  }

  .diesel-tracks__hero-contents {
    color: var(--nts-white);
    display: flex;
    height: calc(100vh - 152px);
    justify-content: center;
    left: 0;
    padding: 120px 0 56px;
    position: absolute;
    text-align: center;
    top: 10%;
    width: 100%;
  }

  .diesel-tracks__hero-contents-wrapper {
    padding: 0 24px;
  }

  .diesel-tracks__hero-heading {
    font-size: 38px;
    line-height: 1;
    margin: 0 auto;
    margin-bottom: 32px;
    max-width: 480px;
    text-align: center;
  }

  .diesel-tracks__hero-diesel-tracks-logo {
    margin-bottom: 32px;
    width: 250px;
  }

  .diesel-tracks__text-block {
    background-color: var(--diesel-tracks-accent-color);
    color: var(--nts-white);
    margin: 70px 0;
    text-align: center;
  }

  .diesel-tracks__text-block-wrapper {
    margin: 0 auto;
    max-width: 650px;
    padding: 0 24px;
  }

  .diesel-tracks__text-block-heading {
    font-size: 28px;
    letter-spacing: 0.28;
    line-height: 32px;
    margin: 0;
    margin-bottom: 16px;
    text-transform: none;
  }

  .diesel-tracks__paragraph {
    font-size: 16px;
    letter-spacing: 0.16;
    line-height: 20px;
    margin: 0 auto;
    margin-bottom: 24px;
    max-width: 590px;
  }

  .diesel-tracks__paragraph:last-child {
    margin-bottom: 0;
  }

  .nts-button.diesel-tracks__hero-cta {
    border: 2px solid var(--nts-white);
    padding: 8px 12px;
    transition: color 0.1s, border 0.1s, background 0.1s;
  }

  .nts-button.diesel-tracks__hero-cta:focus,
  .nts-button.diesel-tracks__hero-cta:hover {
    background-color: var(--nts-white);
    border-color: var(--nts-white);
    color: var(--nts-black);
  }

  .diesel-tracks__hero-cta-wrapper {
    align-items: center;
    display: flex;
  }

  .nts-button.diesel-tracks__hero-cta .button {
    font-fize: 16px;
    line-height: 22px;
  }

  .diesel-tracks__hero-cta svg {
    fill: var(--nts-white);
    height: 26px;
    transition: fill 0.1s;
    width: 24px;
  }

  .nts-button.diesel-tracks__hero-cta:focus svg,
  .nts-button.diesel-tracks__hero-cta:hover svg {
    fill: var(--nts-black);
  }

  .diesel-tracks__map {
    margin: 32px 0 0;
  }

  .diesel-tracks__map-wrapper {
    margin-bottom: 24px;
    padding: 0 12px;
  }

  .diesel-tracks__map-image-mobile {
    display: block;
    width: 100%;
  }

  .diesel-tracks__episodes {
    background-color: var(--diesel-tracks-accent-color);
    color: var(--nts-white);
    margin: 70px 0;
  }

  .diesel-tracks__episodes-header {
    padding: 0 24px;
  }

  .diesel-tracks__episodes-heading {
    font-size: 21px;
    line-height: 26px;
    margin: 0;
    margin-bottom: 12px;
    text-align: center;
  }

  .diesel-tracks__episodes-link {
    color: var(--nts-white);
    text-decoration: none;
  }

  .diesel-tracks__episodes-link:focus,
  .diesel-tracks__episodes-link:hover {
    background-color: var(--nts-white);
    color: var(--diesel-tracks-accent-color);
  }

  .diesel-tracks__episodes-loading,
  .diesel-tracks__episodes-error {
    margin: 24px 0;
    text-align: center;
  }

  .diesel-tracks .editorial-grid__item-header:hover,
  .diesel-tracks .editorial-grid__item-header:focus {
    color: var(--diesel-tracks-accent-color);
  }

  .diesel-tracks .editorial-grid__item-header:hover .editorial-grid__item-header-title,
  .diesel-tracks .editorial-grid__item-header:focus .editorial-grid__item-header-title {
    color: var(--diesel-tracks-accent-color);
  }

  .diesel-tracks__map-filter {
    padding: 0 8px;
  }

  .diesel-tracks__map-filter-list {
    display: flex;
    flex-wrap: wrap;
  }

  .diesel-tracks__map-filter-item {
    margin: 4px;
  }

  .diesel-tracks__map-filter-label {
    border: 2px solid var(--nts-white);
    display: block;
    font-size: 18px;
    line-height: 26px;
    padding: 8px 12px 6px;
  }

  .diesel-tracks__map-filter-input:checked + .diesel-tracks__map-filter-label {
    background-color: var(--nts-white);
    color: var(--diesel-tracks-accent-color);
  }

  .diesel-tracks__map--desktop {
    display: none;
  }

  .diesel-tracks__spotify {
    color: var(--nts-white);
    position: relative;
  }

  .diesel-tracks__bg-image--spotify-section {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: absolute;
    height: 100%;
    z-index: 0;
  }

  .diesel-tracks__spotify-contents {
    padding: 64px 32px 0;
    position: relative;
    z-index: 1;
  }

  .diesel-tracks__spotify-image {
    width: 100%;
  }

  .diesel-tracks__spotify-image--large {
    display: none;
  }

  .diesel-tracks__spotify-text-block {
    padding: 48px 0;
    text-align: center;
  }

  .diesel-tracks__spotify-heading {
    font-size: 32px;
    line-height: 1;
    margin: 0;
    margin-bottom: 8px;
  }

  .diesel-tracks__spotify-cta-group {
    text-align: center;
  }

  .diesel-tracks__spotify-cta.nts-button {
    display: inline-block;
    font-size: 21px;
    font-weight: 600;
    line-height: 24px;
    padding: 8px 16px;
  }

  .diesel-tracks__multi-videos-block {
    margin: 70px 0;
  }

  .diesel-tracks__multi-videos-block-wrapper {
    padding: 0 24px;
  }

  .diesel-tracks__multi-videos-block-heading {
    margin: 0 auto;
    max-width: 480px;
    text-align: center;
  }

  .diesel-tracks__video-grid {
    margin: 16px 0;
    padding: 0 4px;
  }

  .diesel-tracks__video-grid-item {
    border: 2px solid var(--nts-white);
    margin: 8px;
    padding: 6px;
  }

  .diesel-tracks__video-item {
    height: 0;
    padding-bottom: 56.25%;
    position: relative;
  }

  .diesel-tracks__video-cover-container {
    height: 100%;
    overflow: hidden;
    position: absolute;
    width: 100%;
    z-index: 1;
  }

  .diesel-tracks__video-cover-image {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }

  .diesel-tracks__video-loading {
    background-color: var(--nts-black);
    content: '';
    opacity: 0.7;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    align-items: center;
    display: flex;
    justify-content: center;
    transition: opacity linear 0.2s;
    z-index: 1;
  }

  .diesel-tracks__video-loading svg {
    animation: rotating 1s linear infinite;
    width: 48px
  }

  @keyframes rotating {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  button.diesel-tracks__video-play-button {
    align-items: center;
    background-color: rgba(0, 0, 0, 0.25);
    cursor: pointer;
    display: flex;
    justify-content: center;
    height: 100%;
    padding: 0;
    position: absolute;
    top: 0;
    transition: background-color 0.1s linear;
    left: 0;
    width: 100%;
    z-index: 2;
  }

  button.diesel-tracks__video-play-button::before {
    background-color: transparent;
    content: '';
    opacity: 0.7;
    position: absolute;
    top: 0;
    transition: background-color linear 0.2s;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  button.diesel-tracks__video-play-button:hover::before,
  button.diesel-tracks__video-play-button:focus::after {
    background-color: var(--nts-black);
  }

  .diesel-tracks__video-play-icon-container {
    align-items: center;
    border: 4px solid var(--nts-white);
    border-radius: 10px;
    display: flex;
    height: 56px;
    justify-content: center;
    opacity: 0;
    transition: opacity linear 0.2s;
    width: 70px;
    z-index: 2;
  }

  button.diesel-tracks__video-play-button:hover .diesel-tracks__video-play-icon-container,
  button.diesel-tracks__video-play-button:focus .diesel-tracks__video-play-icon-container {
    opacity: 1;
  }

  button.diesel-tracks__video-play-button svg {
    fill: var(--nts-white);
    width: 32px;
  }

  .diesel-tracks__video-player {
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 0;
  }

  .diesel-tracks__multi-videos-block-body {
    margin-top: 8px;
    text-align: center;
  }

  .diesel-tracks__line-up {
    margin: 36px 0;
    text-align: center;
  }

  .diesel-tracks__line-up:first-child {
    margin-top: 120px;
  }

  .diesel-tracks__line-up-wrapper {
    padding: 0 8px;
  }

  .diesel-tracks__heading-container {
    display: inline-block;
  }

  .diesel-tracks__line-up-header-logo-container {
    margin-bottom: 48px;
  }

  .diesel-tracks__line-up-header-logo {
    width: 100%;
    max-width: 250px;
  }

  .diesel-tracks__line-up-heading {
    background-color: var(--nts-black);
    font-size: 28px;
    margin: 0 auto;
    padding: 2px 10px;
  }

  .diesel-tracks__line-up-subheading {
    background-color: var(--nts-white);
    color: var(--nts-black);
    display: block;
    font-size: 18px;
    padding: 2px 12px;
  }

  .diesel-tracks__line-up-artists {
    margin: 24px auto;
    max-width: 1200px;
  }

  .diesel-tracks__line-up-artist-name {
    font-size: 30px;
    line-height: 1;
    margin: 0;
  }

  .diesel-tracks__line-up-description {
    margin: 0 auto;
    margin-top: 32px;
    margin-bottom: 32px;
    padding: 0 16px;
  }

  .diesel-tracks__section--image-carousel {
    margin: 4px 0;
  }

  .diesel-tracks__section--video-block {
    margin-top: 68px;
    position: relative;
  }

  .diesel-tracks__section--video-block-16-9 .diesel-tracks__hero-heading {
    font-size: 24px;
    line-height: 26px;
    padding: 0 16px;
    margin-bottom: 8px;
    max-width: 286px;
  }

  .diesel-tracks__video-block-loading {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 44px;
    margin: 0 auto;
    width: 44px;
  }

  .diesel-tracks__video-block-loading svg {
    animation: rotating 1s linear infinite;
    width: 42px;
    height: 42px;
  }

  @keyframes rotating {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .diesel-tracks__video-block-cover {
    background-color: var(--diesel-tracks-accent-color);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

  .diesel-tracks__video-block-contents {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 100%;
    text-align: center;
  }

  button.diesel-tracks__video-block-play-button {
    align-items: center;
    border: 2px solid var(--nts-white);
    color: var(--nts-white);
    display: flex;
    height: 44px;
    margin: 0 auto;
    padding: 0;
  }

  button.diesel-tracks__video-block-play-button:focus,
  button.diesel-tracks__video-block-play-button:hover {
    background-color: var(--nts-white);
    color: var(--diesel-tracks-accent-color);
  }

  button.diesel-tracks__video-block-play-button:focus .diesel-tracks__video-block-play-icon-container svg,
  button.diesel-tracks__video-block-play-button:hover .diesel-tracks__video-block-play-icon-container svg {
    fill: var(--diesel-tracks-accent-color);
  }

  .diesel-tracks__video-block-play-icon-container {
    align-items: center;
    display: flex;
    height: 40px;
    justify-content: center;
    transition: opacity linear 0.2s;
    width: 40px;
  }

  .diesel-tracks__video-block-play-icon-container svg {
    fill: var(--nts-white);
    height: 100%;
    width: 100%;
  }

  .diesel-tracks__video-block-play-label {
    font-size: 21px;
    line-height: 29px;
    padding: 6px 18px 5px;
  }

  .diesel-tracks__video-block-player {
    padding: 30% 8px;
  }

  .diesel-tracks__video-block-player-wrapper {
    position: relative;
    height: 0;
    padding-bottom: 56.25%;
  }

  .diesel-tracks__video-block-player iframe {
    border: 2px solid var(--nts-white);
    box-sizing: border-box;
    height: 100%;
    left: 0;
    padding: 8px;
    position: absolute;
    top: 0;
    width: 100%;
  }

  @media(min-width: 768px) {
    .diesel-tracks__section:first-child {
      margin-top: 0;
    }

    .diesel-tracks__section--video-block {
      margin-top: 0;
    }

    .diesel-tracks__hero {
      margin-top: 0;
    }

    .diesel-tracks__hero-contents {
      top: 0;
    }

    .diesel-tracks__hero-heading {
      font-size: 72px;
      max-width: 780px;
    }

    .diesel-tracks__section--video-block-16-9 .diesel-tracks__hero-heading {
      font-size: 68px;
      line-height: 68px;
      max-width: 874px;
      margin-bottom: 48px;
    }

    .diesel-tracks__spotify-image--small {
      display: none;
    }

    .diesel-tracks__spotify-image--large {
      display: block;
    }

    .diesel-tracks__video-grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin: 30px 0;
      padding: 0 24px;
    }

    .diesel-tracks__video-grid-item {
      padding: 8px;
      width: calc(50% - 36px);
    }

    .diesel-tracks__line-up {
      margin: 72px 0 104px;
    }

    .diesel-tracks__line-up:first-child {
      margin-top: 72px;
    }

    .diesel-tracks__line-up-header-logo-container {
      margin-bottom: 60px;
    }

    .diesel-tracks__line-up-wrapper {
      margin: 0 24px;
    }

    .diesel-tracks__line-up-heading {
      font-size: 62px;
      padding: 0px 8px;
    }

    .diesel-tracks__line-up-subheading {
      font-size: 34px;
      padding: 6px 6px;
    }

    .diesel-tracks__line-up-artists {
      display: flex;
      margin: 66px auto;
    }

    .diesel-tracks__line-up-artists-list {
      width: 50%;
    }

    .diesel-tracks__line-up-artist {
      text-align: center;
    }

    .diesel-tracks__line-up-artist-name {
      font-size: 60px;
      line-height: 0.9;
    }

    .diesel-tracks__line-up-description {
      margin-top: 48px;
      margin-bottom: 48px;
    }

    .diesel-tracks__video-block-player {
      padding: 10%;
    }
  }

  @media(min-width: 1025px) {
    .diesel-tracks__hero-contents {
      flex-direction: column-reverse;
    }

    .diesel-tracks__hero-diesel-logo {
      display: block;
    }

    .diesel-tracks__bg-image--small {
      display: none;
    }

    .diesel-tracks__bg-image--large {
      display: block;
    }

    .diesel-tracks__hero-diesel-tracks-logo {
      margin-bottom: 38px;
      width: 20%;
    }

    .diesel-tracks__hero-heading {
      font-size: 90px;
      line-height: 96px;
      margin: 0 auto;
      margin-bottom: 40px;
      max-width: 1200px;
      text-align: center;
    }

    .diesel-tracks__text-block {
      margin: 80px 0;
    }

    .diesel-tracks__text-block-heading {
      font-size: 34px;
      letter-spacing: 1.36;
      line-height: 36px;
      margin-bottom: 12px;
    }

    .diesel-tracks__paragraph {
      font-size: 18px;
      letter-spacing: 0.18;
      line-height: 20px;
    }

    .diesel-tracks__map--mobile {
      display: none;
    }

    .diesel-tracks__map--desktop {
      display: block;
    }

    .diesel-tracks__map-wrapper {
      padding: 0;
    }

    .diesel-tracks__map-image-mobile {
      display: none;
    }

    .diesel-tracks__map--desktop #africaPath,
    .diesel-tracks__map--desktop #asiapath,
    .diesel-tracks__map--desktop #europePath,
    .diesel-tracks__map--desktop #nAmericaPath,
    .diesel-tracks__map--desktop #sAmericaPath,
    .diesel-tracks__map--desktop #oceaniaPath {
      fill: var(--nts-white);
    }

    .diesel-tracks__map--desktop #africaName,
    .diesel-tracks__map--desktop #asiaName,
    .diesel-tracks__map--desktop #europeName,
    .diesel-tracks__map--desktop #nAmericaName,
    .diesel-tracks__map--desktop #sAmericaName,
    .diesel-tracks__map--desktop #oceaniaName {
      fill: var(--diesel-tracks-accent-color);
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.1s;
    }

    .diesel-tracks__map--desktop circle {
      pointer-events: none;
      fill: var(--nts-black);
      transition: opacity 0.1s;
    }

    .diesel-tracks__map--desktop .cls-4 {
      fill: #00000033;
    }

    .diesel-tracks__map--desktop path {
      cursor: pointer;
      transition: fill 0.1s;
    }

    #DieselTracksMap.is-active #asia:not(.is-selected) circle,
    #DieselTracksMap.is-active #europe:not(.is-selected) circle,
    #DieselTracksMap.is-active #africa:not(.is-selected) circle,
    #DieselTracksMap.is-active #oceania:not(.is-selected) circle,
    #DieselTracksMap.is-active #nAmerica:not(.is-selected) circle,
    #DieselTracksMap.is-active #sAmerica:not(.is-selected) circle {
      opacity: 0.2;
    }

    #DieselTracksMap.is-active #asia:not(.is-selected) #asiapath,
    #DieselTracksMap.is-active #europe:not(.is-selected) #europePath,
    #DieselTracksMap.is-active #africa:not(.is-selected) #africaPath,
    #DieselTracksMap.is-active #oceania:not(.is-selected) #oceaniaPath,
    #DieselTracksMap.is-active #nAmerica:not(.is-selected) #nAmericaPath,
    #DieselTracksMap.is-active #sAmerica:not(.is-selected) #sAmericaPath {
      fill: var(--diesel-tracks-map-inactive-color);
    }

    .diesel-tracks__map--desktop #asia:hover #asiapath,
    .diesel-tracks__map--desktop #europe:hover #europePath,
    .diesel-tracks__map--desktop #africa:hover #africaPath,
    .diesel-tracks__map--desktop #oceania:hover #oceaniaPath,
    .diesel-tracks__map--desktop #nAmerica:hover #nAmericaPath,
    .diesel-tracks__map--desktop #sAmerica:hover #sAmericaPath {
      fill: var(--diesel-tracks-map-hover-color) !important;
    }

    .diesel-tracks__map--desktop #asia:hover circle,
    .diesel-tracks__map--desktop #europe:hover circle,
    .diesel-tracks__map--desktop #africa:hover circle,
    .diesel-tracks__map--desktop #oceania:hover circle,
    .diesel-tracks__map--desktop #nAmerica:hover circle,
    .diesel-tracks__map--desktop #sAmerica:hover circle {
      opacity: 0.6 !important;
    }

    .diesel-tracks__map--desktop #asia:hover #asiaName,
    .diesel-tracks__map--desktop #europe:hover #europeName,
    .diesel-tracks__map--desktop #africa:hover #africaName,
    .diesel-tracks__map--desktop #oceania:hover #oceaniaName,
    .diesel-tracks__map--desktop #nAmerica:hover #nAmericaName,
    .diesel-tracks__map--desktop #sAmerica:hover #sAmericaName {
      opacity: 1;
    }

    #DieselTracksMap.is-active #asia.is-selected #asiapath,
    #DieselTracksMap.is-active #europe.is-selected #europePath,
    #DieselTracksMap.is-active #africa.is-selected #africaPath,
    #DieselTracksMap.is-active #oceania.is-selected #oceaniaPath,
    #DieselTracksMap.is-active #nAmerica.is-selected #nAmericaPath,
    #DieselTracksMap.is-active #sAmerica.is-selected #sAmericaPath {
      fill: var(--nts-white) !important;
    }

    #DieselTracksMap.is-active #asia.is-selected circle,
    #DieselTracksMap.is-active #europe.is-selected circle,
    #DieselTracksMap.is-active #africa.is-selected circle,
    #DieselTracksMap.is-active #oceania.is-selected circle,
    #DieselTracksMap.is-active #nAmerica.is-selected circle,
    #DieselTracksMap.is-active #sAmerica.is-selected circle {
      opacity: 1 !important;
    }

    #DieselTracksMap.is-active #asia.is-selected #asiaName,
    #DieselTracksMap.is-active #europe.is-selected #europeName,
    #DieselTracksMap.is-active #africa.is-selected #africaName,
    #DieselTracksMap.is-active #oceania.is-selected #oceaniaName,
    #DieselTracksMap.is-active #nAmerica.is-selected #nAmericaName,
    #DieselTracksMap.is-active #sAmerica.is-selected #sAmericaName {
      opacity: 1;
    }

    .diesel-tracks__episodes {
      margin: 80px 0;
    }

    .diesel-tracks__episodes-heading {
      font-size: 28px;
      line-height: 32px;
    }

    .diesel-tracks__spotify-col:first-child {
      width: 50%;
    }

    .diesel-tracks__spotify-col:last-child {
      flex-shrink: 0;
      align-items: center;
      display: flex;
      width: 50%;
    }

    .diesel-tracks__spotify-contents {
      align-items: center;
      display: flex;
      padding: 72px 96px;
      padding-right: 0;
    }

    .diesel-tracks__spotify-text-block {
      margin: auto;
      max-width: 480px;
      padding: 0 96px;
    }

    .diesel-tracks__multi-videos-block {
      margin: 84px 0;
    }

    .diesel-tracks__multi-videos-block-heading {
      font-size: 32px;
      max-width: auto;
    }

    .diesel-tracks__line-up-artist-name {
      font-size: 82px;
    }

    .diesel-tracks__video-grid-item {
      width: calc(33.33% - 36px);
    }
  }

  @media(max-width: 767px) {
    .diesel-tracks__section--video-block-16-9 .diesel-tracks__video-block-player {
      padding: 8px;
    }
  }
`

export default DieselTracksStyles
